import React, { useState, useEffect, useContext } from "react";

import DataTable from "react-data-table-component";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";
import EditIcon from "@mui/icons-material/Edit";
import { ActionContext } from "context/ActionContext";
import {
  AutocompleteMultiselectCheckbox,
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

import useActionTable from "./useActionTable.js";

//import "react-table/react-table.css";

// @mui/icons-material

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

function RTResultsFluid (props) {
  const { setCalculate } = props;
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const { gridState } = useActionTable();
  const appContext = useContext(ActionContext);
  const { action, setAction } = appContext;
  const [newData, setNewData] = useState([]);
  const [editableRowId, setEditableRowId] = useState(false);

  const classes = useStyles();

  useEffect(() => {
    setNewData(gridState.data);
  }, [gridState.data]);

  const columns = [
    {
      name: "Nom",
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
    },
    {
      name: "Production (MWh)",
      selector: (row) => row.realproduction,
      sortable: true,
      maxWidth: "10rem",
      omit: action?.parameters?.general?.category !== 'renewables',
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].realproduction}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="realproduction"
          />
        ) : (
          row.realproduction ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.realproduction) : ''
        ),
    },
    {
      name: "Economies (MWh ou m3)",
      selector: (row) => row.realsavings,
      sortable: true,
      maxWidth: "10rem",
      omit: action?.parameters?.general?.category === 'contracts',
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].realsavings}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="realsavings"
          />
        ) : (
          row.realsavings ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.realsavings) : ''
        ),
    },
    {
      name: "Economies / référence (%)",
      selector: (row) => row.savingspercentage,
      sortable: true,
      maxWidth: "10rem",
      omit: action?.parameters?.general?.category === 'contracts',
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].savingspercentage}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="savingspercentage"
          />
        ) : (
          row.savingspercentage ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.savingspercentage) : ''
        ),
    },
    {
      name: "Economies (€)",
      selector: (row) => row.savingseuro,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].savingseuro}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="savingseuro"
          />
        ) : (
          row.savingseuro ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.savingseuro) : ''
        ),
    },
    {
      name: "Economies (kg eq CO2)",
      selector: (row) => row.savingsco2,
      sortable: true,
      cell: (row) =>
        editableRowId === row.id ? (
          <IntInput
            //inputTitle={actionVar[params].observations}
            intInput={newData[indexFinder(row.id)].savingsco2}
            handleIntInputChange={(e) => handleChange(e, row.id)}
            name="savingsco2"
          />
        ) : (
          row.savingsco2 ? new Intl.NumberFormat('fr-FR',{maximumFractionDigits : 2}).format( row.savingsco2) : ''
        ),
    },
    actionplanupdate && {
      name: "",
      sortable: false,
      width: "4rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer">
              <Button
                onClick={editEnabled(row)}
                color={editableRowId === row.id ? "info" : "success"}
                className={classes.actionButton}
              >
                {editableRowId === row.id ? (
                  <CheckIcon fontSize="large" />
                ) : (
                  <EditIcon fontSize="large" />
                )}
              </Button>
            </Tooltip>
          </div>
        </>
      ),
    },
  ];

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    const indexOfId = newData.findIndex((obj) => obj.id == id);

    let newArray = [...newData];
    newArray[indexOfId][name] = value;

    setNewData(newArray);
    setCalculate(true);
  };
  const editEnabled = (row) => async () => {
    console.log("edit is clicked", row.id);

    editableRowId === row.id
      ? setEditableRowId(null)
      : setEditableRowId(row.id);
  };
  function indexFinder(rowId) {
    console.log(rowId, newData);
    const indexOfId = newData.findIndex((obj) => obj.id == rowId);

    return indexOfId;
  }

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noHeader={true}
        //title="Selection des parois"
        noDataComponent="Aucun fluide selectionné"
        columns={columns}
        subHeader
        persistTableHead
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        highlightOnHover
        {...gridState}
      />
    </>
  );
};

export default RTResultsFluid;
